export default __webpack_public_path__ + "static/media/additional-baggage.5e861534.svg";